import React from 'react'
import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import MakerHubRelatedArticle from '../MakerHubRelatedArticle/MakerHubRelatedArticle'
import { MakerHubRelatedArticleListProps } from './MakerHubRelatedArticleList.types'

const MakerHubRelatedArticleList = ({
  title,
  articles,
  className,
}: MakerHubRelatedArticleListProps) => {
  return (
    <div className={classNames('flex flex-col gap-4', className)}>
      {title && (
        <Typography tag={TypographyTag.p} variant={TypographyVariant.Heading5}>
          {title}
        </Typography>
      )}
      {articles?.map((article) => {
        return (
          <MakerHubRelatedArticle
            key={article.articleId}
            article={article}
            className={classNames('border-b pb-6')}
          />
        )
      })}
    </div>
  )
}

export default MakerHubRelatedArticleList
